import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import osoIcon from "../../../assets/christmasCard/avatares/OSO.png";
import zorroIcon from "../../../assets/christmasCard/avatares/ZORRO.png";
import pinguinoIcon from "../../../assets/christmasCard/avatares/PINGUINO.png";
import renoIcon from "../../../assets/christmasCard/avatares/RENO_COMPLETO.png";

export const IconManager = ({
  oso,
  setOso,
  pinguino,
  setPinguino,
  reno,
  setReno,
  zorro,
  setZorro,
}) => {
  return (
    <Container className="christmasCard__addOnSelectorContainer">
      <Row>
        <Col>
          <Button
            id={zorro ? "selected" : ""}
            onClick={() => {
              setZorro(!zorro);
              document.getElementById("divCanvas").scrollIntoView(false);
            }}
          >
            <img src={zorroIcon} alt="icono zorro" />
          </Button>
        </Col>
        <Col>
          <Button
            id={pinguino ? "selected" : ""}
            onClick={() => {
              setPinguino(!pinguino);
              document.getElementById("divCanvas").scrollIntoView(false);
            }}
          >
            <img src={pinguinoIcon} alt="icono pinguino" />
          </Button>
        </Col>
        <Col>
          <Button
            id={oso ? "selected" : ""}
            onClick={() => {
              setOso(!oso);
              document.getElementById("divCanvas").scrollIntoView(false);
            }}
          >
            <img src={osoIcon} alt="icono oso" />
          </Button>
        </Col>
        <Col>
          <Button
            id={reno ? "selected" : ""}
            onClick={() => {
              setReno(!reno);
              document.getElementById("divCanvas").scrollIntoView(false);
            }}
          >
            <img src={renoIcon} alt="icono Reno" />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
